import React from "react";
import {NavLink} from "react-router-dom";
import {AddLangLink} from "../../../AdminPart/src/Constants";

function ChangeNavLink (props) {
    if (props.children.props) {return (<NavLink end to={props.lang === 'noAdd' ? props.to : AddLangLink()[props.lang] + props.to} className={({isActive}) => (isActive ? props.ActiveClass : props.ActiveClassNot)}>{props.children}</NavLink>)}
    else  {return (<NavLink end to={props.lang === 'noAdd' ? props.to : AddLangLink()[props.lang] + props.to} className={({isActive}) => (isActive ? props.ActiveClass : props.ActiveClassNot)}>{props.children}</NavLink>)}
}

export default ChangeNavLink
